export default __webpack_public_path__ + "static/worksans-semibold-webfont-d345a2afcc4208276952a9a3fe7035f7.woff";